import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-41-small', 'Number41Small', [["path",{"d":"M15 8h1v8"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3"}],["path",{"d":"M10 8v8"}]]);